import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Airlines = () => {
  const [showAll, setShowAll] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="list-trip">
      <h4>{t("airlines")}</h4>
      <ul className="list-unstyled p-0 m-0">
        {/* Always visible */}
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck1" />
              <label className="form-check-label" htmlFor="gridCheck1">
                {t("airIndia")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">120</div>
          </div>
        </li>
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck2" />
              <label className="form-check-label" htmlFor="gridCheck2">
                {t("etihadAirways")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">21</div>
          </div>
        </li>
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck3" />
              <label className="form-check-label" htmlFor="gridCheck3">
                {t("gulfAir")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">62</div>
          </div>
        </li>
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck4" />
              <label className="form-check-label" htmlFor="gridCheck4">
                {t("indigo")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">33</div>
          </div>
        </li>
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck5" />
              <label className="form-check-label" htmlFor="gridCheck5">
                {t("lufthansa")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">25</div>
          </div>
        </li>

        {/* Hidden list when showAll = false */}
        {showAll && (
          <>
            <li>
              <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                <div className="radioBox">
                  <input className="form-check-input" type="checkbox" id="gridCheck6" />
                  <label className="form-check-label" htmlFor="gridCheck6">
                    {t("qatarAirways")}
                  </label>
                </div>
                <div className="d-flex align-items-center text-right-box">45</div>
              </div>
            </li>
            <li>
              <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                <div className="radioBox">
                  <input className="form-check-input" type="checkbox" id="gridCheck7" />
                  <label className="form-check-label" htmlFor="gridCheck7">
                    {t("emirates")}
                  </label>
                </div>
                <div className="d-flex align-items-center text-right-box">78</div>
              </div>
            </li>
            <li>
              <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                <div className="radioBox">
                  <input className="form-check-input" type="checkbox" id="gridCheck8" />
                  <label className="form-check-label" htmlFor="gridCheck8">
                    {t("singaporeAirlines")}
                  </label>
                </div>
                <div className="d-flex align-items-center text-right-box">12</div>
              </div>
            </li>
          </>
        )}
      </ul>

      {/* Toggle button */}
      <div className="drop-box-price">
        <button
          type="button"
          className="btn-text d-flex align-items-center gap-2 bg-transparent border-0"
          onClick={() => setShowAll(!showAll)}
        >
          <span>{showAll ? t("showLess") : t("showAll")}</span>
          <svg
            width="15"
            height="9"
            viewBox="0 0 15 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: showAll ? "rotate(180deg)" : "none" }}
          >
            <path
              d="M1 1L7.5 7L14 1"
              stroke="#33A7F6"
              strokeWidth="2"
              strokeLinecap="round"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Airlines;
